export default __webpack_public_path__ + "static/media/logo.8216ced7.svg";